var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"mb-1 text-subtitle-2 text--secondary font-weight-regular"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }